<template>
  <div class="flex">
    <examine
      :title="title"
      :checked="checked"
      @handleCheck="val => handleChange(val)"
    />
    <el-form
      v-if="checked"
      ref="form"
      :model="form"
    >
      <el-form-item label="" required>
        <el-col :span="10">
          <el-form-item
            prop="minTemperature"
            :rules="[
              { required: true, message: '请输入', trigger: ['change','blur'] },
              { type: 'number', message: '输入为[-99,99]的整数'},
              { validator:validateMin,trigger:'blur'}
            ]"
          >
            <el-input-number
              v-model="form.minTemperature"
              :style="{width:'100px'}"
              size="small"
              :min="-99"
              :max="99"
              :step="1"
              step-strictly
              placeholder="最低温度"
              @input="handleInput('maxTemperature')"
            />
          </el-form-item>
        </el-col>
        <el-col class="center" :span="2">
          ~
        </el-col>
        <el-col :span="10">
          <el-form-item
            prop="maxTemperature"
            :rules="[
              { required: true, message: '请输入', trigger: ['change','blur'] },
              { type: 'number', message: '输入为[-99,99]的整数'},
              { validator:validateMax,trigger:'blur'}
            ]"
          >
            <el-input-number
              v-model="form.maxTemperature"
              :style="{width:'100px'}"
              size="small"
              :min="-99"
              :step="1"
              step-strictly
              placeholder="最高温度"
              :max="99"
              @input="handleInput('minTemperature')"
            />
          </el-form-item>
        </el-col>
        <el-col class="line" :span="2">
          ℃
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import examine from './examine.vue';

export default {
  components: { examine },
  props: ['title', 'prop', 'detail'],
  data() {
    const validateMin = (rule, value, callback) => {
      if (!this.isEmpty(value) && !this.isEmpty(this.form.maxTemperature)) {
        const min = Number(value);
        const max = Number(this.form.maxTemperature);
        if (min > max) {
          callback(new Error('温区范围区间有误'));
        }
        callback();
      }
      callback();
    };
    const validateMax = (rule, value, callback) => {
      if (!this.isEmpty(value) && !this.isEmpty(this.form.minTemperature)) {
        const max = Number(value);
        const min = Number(this.form.minTemperature);
        if (min > max) {
          callback(new Error('温区范围区间有误'));
        }
        callback();
      }
      callback();
    };
    return {
      form: {},
      validateMin,
      validateMax,
      checked: false,
    };
  },
  watch: {
    detail: {
      handler(val) {
        if (!val) {
          this.checked = false;
          return;
        }
        const { checkTruckTemperature, minTemperature, maxTemperature } = val;
        this.checked = checkTruckTemperature;
        this.form = {
          minTemperature,
          maxTemperature,
        };
      },
      immediate: true,
    },
  },
  methods: {
    isEmpty(val) {
      if (val === null || val === undefined || val === '') {
        return true;
      }
      return false;
    },
    handleChange(val) {
      this.checked = val;
      if (!val) {
        this.$emit('handleChange', {
          checkTruckTemperature: false,
          minTemperature: null,
          maxTemperature: null,
        });
        this.form = {
          minTemperature: undefined,
          maxTemperature: undefined,
        };
      }
    },
    handleInput(key) {
      if (this.$refs.form) {
        this.$refs.form.clearValidate(key);
      }
      this.$emit('handleChange', {
        ...this.form,
        checkTruckTemperature: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form{
  position: relative;
  top:30px;
  margin-left: 50px;
  .center{
    text-align: center;
    padding: 0 10px;
  }
  .el-input-number__decrease{
    display: none;
  }
  .el-input-number__increase{
    display: none;
  }
  .el-input-number .el-input__inner{
    padding: 0 2px!important;
  }
}
</style>
